export function settingsLink(viewer?: Optional<{ username: string }>) {
  if (viewer) {
    return `/user/${viewer.username}`;
  } else {
    return `/user/me`;
  }
}
